module.exports = {"title":"Introduction","body":"<p><strong>AlphabetJS</strong> is the latest and greatest Javascript Framework. It’s\namazing and wonderful and you’ll probably love it more than all of the\nother ones.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./docs/index.md
 ** module id = 476
 ** module chunks = 0
 **/